export default __webpack_public_path__ + "static/media/service1.8e35d1fb.jpg";